export default __webpack_public_path__ + "static/media/icons-close-green-18-px.8d3e2f46.svg";